import { FunctionComponent } from 'react';
import './styles/Button.scss';

interface IButtonProps {
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  loading?: boolean;
  onClick?: () => void;
  children: any;
}
export const Button: FunctionComponent<IButtonProps> = (props: IButtonProps) => {

  const {
    children,
    type,
    disabled,
    loading,
    onClick
  } = props;

  return (
    <button
      className='ppa-schedule-button'
      disabled={disabled || loading}
      type={type ?? 'button'}
      onClick={onClick}
    >
      {children}
      {loading && (
        <div className='loading-spinner'></div>
      )}
    </button>
  )
}